import { Component, Inject, Input, forwardRef } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { CustomerFactoryService } from './customer-factory.service';
import { CustomerModel }          from './models/customer';
import { MessagesService }        from '../messages/messages.service';

@Component({
  selector   : 'wor-customer-send-portal-invitation',
  template: require('./customer-send-portal-invitation.component.html')
})
export class CustomerSendPortalInvitationComponent {
  @Input() customer: CustomerModel;

  loading: boolean = false;

  constructor (
    public activeModal: NgbActiveModal,
    @Inject(forwardRef(() => CustomerFactoryService)) private customerFactoryService: CustomerFactoryService,
    private messagesService: MessagesService,
    private translateService: TranslateService
  ) {}

  confirm (sendAsSms: boolean): void {
    this.loading = true;

    this.customerFactoryService.confirmPortalInvitation(sendAsSms)
      .then(() => {
        this.messagesService.show(
          this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.INVITATION_SENT'),
          'success'
        );

        this.activeModal.close();
      })
      .catch((err: any) => {
        this.messagesService.error(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
